import { Button, Col, Row, Stack } from "react-bootstrap"
import { ReactComponent as ReloadIcon } from "../svgs/refresh.svg"
import Label from "./Label"
import React from "react"

type StackAction = {
    icon     :any
    onClick: () => void
}

type CStackProps = {
    header?    :string
    children?  :any
    padding?   :string
    actions?   : StackAction[]
    onReload?    : () => void
    collapsible? : boolean
    defaultExpanded? : boolean
}

const CStack:React.FC<CStackProps> = ({   
        header="", 
        children = [<></>], 
        padding="15px 0",
        actions=[],
        onReload = null,
        collapsible = false,
        defaultExpanded = true,
    }) => {
    const [expanded, setExpanded] = React.useState(defaultExpanded);
    if (onReload) {
        actions = [...actions,{
            icon: <ReloadIcon width={20} height={20}/>,
            onClick: onReload
        }]
    }
    return <div style={{padding:padding}}>
        {/* {false && header !== "" && <Stack direction="horizontal">
            <Label padding="10px 0" fontWeight="600" color="black">{header}</Label>
            {actions.length > 0 && actions.map( (item:StackAction) => <></>)}
            <Button
                onClick={onReload!}
                variant=""
                style={{
                    backgroundColor:"transparent",
                    padding: "3px 3px",
                    color:"#565656", 
                    fontSize:"large", 
                    fontWeight:"500"}
                }>
                <ReloadIcon /> 
            </Button>
        </Stack>} */}
        <Row style={{maxWidth:"600px"}}>
            {header !== "" && <Col >
                <div style={{ display: 'flex'}}>
                    {collapsible && (
                        <Button
                            onClick={() => setExpanded(!expanded)}
                            variant=""
                            style={{
                                backgroundColor: "transparent",
                                padding: "0 5px",
                                color: "#565656",
                                fontSize: "14px"
                            }}
                        >
                            {expanded ? '▼' : '▶'}
                        </Button>
                    )}
                    <Label padding="10px 0" fontWeight="600" color="black">{header}</Label>
                </div>
            </Col>}
            {actions.length > 0 && <Col xs={4} lg={4} ><div style={{position:"absolute",right:"30px"}}>{
                actions.map( (item:StackAction, index:number) => <React.Fragment key={index}>
                    <Button
                        onClick={item.onClick}
                        variant=""
                        style={{
                            backgroundColor:"transparent",
                            margin: "5px 0px",
                            padding: "3px 3px",
                            color:"#565656", 
                            fontSize:"large", 
                            fontWeight:"500"}
                        }>
                        {item.icon} 
                    </Button>
                </React.Fragment>)
            }</div></Col>}
        </Row>
        {(!collapsible || expanded) && (
            <Stack gap={1}>
                {children && children.length !== undefined && children.length >= 1 && [...children]}
                {children && children.length === undefined && children}
            </Stack>
        )}
    </div>
}

export default CStack